import { FormControl, Validators } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable()
export class LoginForm {
    username = new FormControl('', [Validators.required, Validators.email]);
    password = new FormControl('', Validators.required);
    rememberMe = new FormControl(false);
}
